import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { withRFSToken } from '../../../Services/axios.js';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Edit from "../../../assets/images/edit.png";
import { jqxCookieCall } from '../../../Components/common/CommonFunctions.js';

const LocationSettings = () => {
    const isMounted = useRef(false);
    const gridRefs = useRef(null);
    const [destinationList, setDestinationList] = useState([]);
    const [addLocationModal, setAddLocationModal] = useState(false);
    const [stationId, setStationId] = useState();
    const [location, setLocation] = useState();
    const [editId,setEditId] = useState(null);
    const [allData, setAlldata] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    let checkUlds = [];

    useEffect(() => {
        if (isMounted.current) return;
        fetchDestination();
        loadGrid();
        isMounted.current = true;
    }, []);

    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post('uld-forms/get-destinations')
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformData = innerData ? innerData.map((item) => ({
                        label: item.port_code,
                        value: item.station_id,
                        station_name: item.station_name
                    })) : []
                    setDestinationList(transformData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleShow = () => {
        setAddLocationModal(true);
        setStationId('');
        setLocation('');
    };
    const handleClose = () => {
        setAddLocationModal(false);
        setStationId('');
        setLocation('');
    };

    const handleActiveInvoice = async (status) => {
        let filterStatus;
        let payload = {}
        if (status == 1) {
            const alreadyActive = gridSelect.filter(i => i.activity_status == 1);
            if (alreadyActive.length === gridSelect.length) {
                toast.success("Selected locations are already active.");
                return;
            }
            filterStatus = gridSelect.filter(i => i.activity_status == 0).map(d => d.id);
            payload = { active_location_ids: filterStatus }
        } else if (status == 0) {
            const alreadyInactive = gridSelect.filter(i => i.activity_status == 0);
            if (alreadyInactive.length === gridSelect.length) {
                toast.error("Selected locations are already inactive.");
                return;
            }
            filterStatus = gridSelect.filter(i => i.activity_status == 1).map(d => d.id)
            payload = { inactive_location_ids: filterStatus }
        }
        if (filterStatus.length === 0) {
            toast.error("Please select at least one location to change status.");
            return;
        }
        try {
            const res = await withRFSToken.post('forwarder-location/update-status', payload)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                        loadGrid();
                        setGridSelect([]);
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    const handleSave = async () => {
        if (!stationId || !location) {
            toast.success("Please fill all required fields.");
            return;
        }
        const payload = {
            ...(editId && { id: editId }),
            station: stationId,
            location: location
        };
        try {
            const res = await withRFSToken.post('forwarder-location/save', payload);
            if (res.data.response_code == 200) {
                toast.success(res.data.response_msg);
                loadGrid();
                setAddLocationModal(false);
                setStationId('');
                setLocation('');
                setEditId(null);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    const loadGrid = () => {
        // const token = 'Bearer ' + localStorage.RFS;
        jqxCookieCall();
        const source = {
            datatype: 'json',
            url: `${process.env.REACT_APP_RFS_URL}forwarder-location/list`,
            root: 'Rows',
            cache: false,
            datafields: [
                { name: 'id', type: 'string' },
                { name: 'location', type: 'string' },
                { name: 'activity_status', type: 'string' },
                { name: 'created_by', type: 'string' },
                { name: 'station', type: 'string' }
            ],
            // beforeSend: (jqXHR) => {
            //     jqXHR.setRequestHeader('Authorization', token);
            // },
            filter: function (allfilters) {
                window.$(gridRefs.current).jqxGrid('clearselection');
                window.$(gridRefs.current).jqxGrid("updatebounddata", "filter");
            },
            beforeprocessing: function (data) {
                setAlldata(data.response_data);
            }
        };
        const dataAdapter = new window.$.jqx.dataAdapter(source);
        const columns = [
            {
                text: 'Actions',
                cellsrenderer: function () {
                    return '<div class="grid_actions"><img src="' + Edit + '" class="row_edit" /></div>';
                },
                width: '6%', filterable: false,
            },
            {
                text: 'Sl. No',
                datafield: 'sl_no',
                width: '10%',
                filterType:'input',
                cellsrenderer: (rowIndex) => {
                    const serialNo = rowIndex + 1;
                    const formattedNo = serialNo < 10 ? `0${serialNo}` : `${serialNo}`;
                    return `<div class="grid_actions">${formattedNo}</div>`;
                }
            },
            {
                text: 'Status',
                datafield: 'activity_status',
                width: '10%',
                filtertype: 'checkedlist',
                filteritems: [
                    { label: 'Active', value: 'Active' },
                    { label: 'Inactive', value: 'Inactive' },
                ],
                cellsrenderer: (rowIndex, dataField, cellValue) => {
                    const isActive = cellValue === '1' || cellValue === 1;
                    const status = isActive ? 'Active' : 'Inactive';
                    const colorClass = isActive ? 'text-success' : 'text-danger';
                    return `<div class="jqx-grid-cell-left-align ${colorClass}" style="margin-top: 12px; margin-left:5px">${status}</div>`;
                }
            },
            { text: 'Location', datafield: 'location', width: '30%', filterType:'input', },
            { text: 'Station', datafield: 'station', width: '10%', filterType:'input', },
            { text: 'Created By', datafield: 'created_by', width: '10%', filterType:'input', },
        ];
        const gridOptions = {
            width: '100%',
            source: dataAdapter,
            columns: columns,
            autoheight: false,
            height: 800,
            sortable: true,
            altrows: false,
            enabletooltips: true,
            editable: false,
            pageable: true,
            selectionmode: 'checkbox',
            pageSize: 50,
            pagesizeoptions: ['50', '100', '200', '500'],
            pagerButtonsCount: 5,
            pagerMode: 'advanced',
            filterable: true,
            filterrowheight: 45,
            showfilterrow: true,
            rowsheight: 42,
            columnsheight: 45,
            virtualmode: true,
            rendergridrows: function (params) {
                return params.data;
            },
            ready: function () {
                // const rows = window.$(gridRefs.current).jqxGrid('getrows');
                // rows.forEach((row, idx) => {
                //     if (row.status === '1' || row.status === 1) {
                //         window.$(gridRefs.current).jqxGrid('selectrow', idx);
                //     }
                // });
            }
        };

        window.$(gridRefs.current).jqxGrid(gridOptions);
        window.$(gridRefs.current).on('click', '.row_edit', function () {
            const rowDiv = window.$(this).closest('[role="row"]');
            const rowIndex = window.$(rowDiv).attr('row-id');
            const rowData = window.$(gridRefs.current).jqxGrid('getrowdata', rowIndex);
            setEditId(rowData?.id);
            setStationId(rowData?.station);
            setLocation(rowData?.location);
            setAddLocationModal(true)
        });
        window.$(gridRefs.current).on('rowselect', (event) => {
            if (event.args.row) {
                const selectedRow = event.args.row;
                const uldNumber = selectedRow.id;
                const selectedRowId = selectedRow.uid;
                if (!checkUlds.includes(uldNumber)) {
                    checkUlds.push(uldNumber);
                }
                setGridSelect(prevGridSelect => {
                    if (!prevGridSelect.some(row => row.id === uldNumber)) {
                        return [...prevGridSelect, selectedRow];
                    }
                    return prevGridSelect;
                });
            } else {
                if (event.args.rowindex.length > 0) {
                    const allIds = window.$(gridRefs.current).jqxGrid('getrows');
                    setGridSelect(allIds);
                } else {
                    setGridSelect([]);
                }
            }
        });
        window.$(gridRefs.current).on('rowunselect', (event) => {
            if (event.args.row) {
                const unselectedRowId = event.args.row.id;
                setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                if (!checkUlds.includes(unselectedRowId)) {
                    checkUlds.push(unselectedRowId);
                } else {
                    checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                }
            }
        });
    };
    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* <div className=""> */}
                {/* <Header page_type='fsm' logo_url='/ForwarderShipments/Export' /> */}
                {/* <Header logo_url={SBack ? SBack : '/ForwarderShipments/Export'} sBackUrl={SBack ? SBack : '/ForwarderShipments/Export'} />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <div className='category_invoice_title'>
                                    <h4>Add Location</h4>
                                    <p>Set your notification preferences for when you are in or away from the dashboard</p>
                                </div>
                                <div className='d-flex justify-content-start mb-3'>
                                    <Button variant="primary me-2" onClick={handleShow}><span className='me-2'><FontAwesomeIcon icon={faPlus} /></span>Add Location</Button>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                            <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handleActiveInvoice('1')}>Active Location</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleActiveInvoice('0')}>Inactive Location</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                                <div className='trashdonload'>
                                    <div ref={gridRefs} className='setting_bookinggrid' ></div>
                                </div>
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}

            <Modal show={addLocationModal} onHide={handleClose} className='addfrom add_category_modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Location</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Station</Form.Label>
                            <Select options={destinationList} value={destinationList.find(option => option.label == stationId) || null} onChange={selected => setStationId(selected ? selected.label : '')} placeholder="Select Station" />
                        </Col>
                        <Col sm="12" className='mb-3'>
                            <Form.Label>Location Name<span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control type="text" placeholder="Enter Location" value={location} onChange={e => setLocation(e.target.value)} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className='justify-content-center'>
                    <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                        <Button type="button" className="btn btn-primary" onClick={handleSave}>Save</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default LocationSettings
